import { TYPES } from '../actions/types';

const initialState = {
  k3agents: [],
  k3tasks: [],
  k3logs: {},
  loading: false,
  error: null,
  totalAgents: 0
};

export const k3agentReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case TYPES.ACTION_GET_K3AGENTS_SUCCESS:
      return {
        ...state,
        k3agents: payload.agents || payload,
        totalAgents: payload.total || 0,
        loading: false
      };

    case TYPES.ACTION_GET_K3AGENT_TASKS_SUCCESS:
      return {
        ...state,
        k3tasks: payload,
        loading: false
      };

    case TYPES.ACTION_GET_K3AGENT_LOGS_SUCCESS:
      return {
        ...state,
        k3logs: {
          ...state.k3logs,
          [payload.task_id]: payload.logs
        },
        loading: false
      };

    case TYPES.ACTION_SET_K3AGENTS_SUCCESS:
      var updatedAgentIds = payload.map(agent => agent._id);

      return {
        ...state,
        k3agents: [
          ...state.k3agents.filter(agent => !updatedAgentIds.includes(agent._id)), 
          ...payload
        ].sort((a, b) => {
          const dateA = new Date(a.createdAt).getTime();
          const dateB = new Date(b.createdAt).getTime();
          return dateB - dateA; // Sort descending (newest first)
        }),
        loading: false,
        error: null
      };

    case TYPES.ACTION_ASSIGN_K3AGENT_JOB_SUCCESS:
      return {
        ...state,
        k3tasks: [payload, ...state.k3tasks],
        loading: false
      };

    case TYPES.ACTION_DELETE_K3AGENT_TASK_SUCCESS:
      return {
        ...state,
        k3tasks: state.k3tasks.filter(task => task._id !== payload),
        loading: false
      };

    case TYPES.ACTION_UPDATE_K3AGENT_TASK_SUCCESS:
      return {
        ...state,
        k3tasks: state.k3tasks.map(task => 
          task._id === payload._id ? payload : task
        ),
        loading: false
      };

    case TYPES.ACTION_GET_K3AGENTS_FAIL:
    case TYPES.ACTION_GET_K3AGENT_TASKS_FAIL:
    case TYPES.ACTION_GET_K3AGENT_LOGS_FAIL:
    case TYPES.ACTION_ASSIGN_K3AGENT_JOB_FAIL:
    case TYPES.ACTION_DELETE_K3AGENT_TASK_FAIL:
    case TYPES.ACTION_UPDATE_K3AGENT_TASK_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    default:
      return state;
  }
}; 